import React, { useState } from "react";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Box,
  Typography,
  Checkbox,
  Grid,
  Paper,
  Autocomplete,
} from "@mui/material";

const FilterTable = () => {
  const [search, setSearch] = useState("");
  const [role, setRole] = useState("");
  const [company, setCompany] = useState("");
  const [status, setStatus] = useState("all");

  return (
    <Paper
      sx={{
        p: 2,
        borderRadius: 2,
        height: "100%",
        border: "1px solid #ebedf0",
      }}
    >
      <Grid container spacing={2} alignItems="center">
        {/* Search Bar */}
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            placeholder="Search company by name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <span style={{ marginRight: 8, rotate: "260deg" }}>⌕</span>
              ),
              sx: { height: 40 },
            }}
            sx={{
              "& .MuiInputBase-root": {
                height: 40,
              },
            }}
          />
        </Grid>

        {/* Filter by Role */}
        <Grid item xs={6} md={2}>
          <Autocomplete
            fullWidth
            options={["Admin", "User", "Manager"]}
            value={role}
            onChange={(event, newValue) => setRole(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Plan"
                sx={{
                  "& .MuiInputBase-root": {
                    height: 40,
                  },
                }}
              />
            )}
          />
        </Grid>

        {/* Filter by Company */}
        <Grid item xs={6} md={2}>
          <Autocomplete
            fullWidth
            options={["Admin", "User", "Manager"]}
            value={role}
            onChange={(event, newValue) => setRole(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Sort By"
                sx={{
                  "& .MuiInputBase-root": {
                    height: 40,
                  },
                }}
              />
            )}
          />
        </Grid>

        {/* Status Filter */}
        <Grid item xs={12} md={4}>
          <FormControl component="">
            <RadioGroup
              row
              value={status}
              sx={{
                color: "grey",
              }}
              onChange={(e) => setStatus(e.target.value)}
            >
              <FormControlLabel
                value="all"
                control={<Radio />}
                label="All Users"
              />
              <FormControlLabel
                value="active"
                control={<Radio />}
                label="Active"
              />
              <FormControlLabel
                value="inactive"
                control={<Radio />}
                label="Inactive"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default FilterTable;
